import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import styles from './album.module.css';
import quran from '../home/images/quran.jpg1.jpg';
import crypto from '../home/images/crypto.jpg';
import ets1 from '../home/images/ets1.jpg';
import car from '../home/images/car.jpg';
import Axel from '../home/images/axel1.jpg';
import comments from '../home/images/comments1.jpg';
import react from '../home/images/react.jpg';
import Ecommerce from '../home/images/e-commerce.jpg';
import maproute from '../home/images/maproute.jpg';
import Moveit from '../home/images/move-1.jpg';

const Album = () => {
  return (
    <div className={` container ${styles.container}`}>
      <h1 className={styles.h1}>PROJECTS<span>.</span></h1>
      <div className="row">
        <div className="col-md-6 mb-4">
          <div className={styles.card}>
            <img src={quran} className={styles.cardImage} alt="Naziv Projekta 1" />
            <div className={styles.cardBody}>
              <h2 className={styles.cardTitle}>Quran app</h2>
              <p className={styles.cardText}>A Quran app for everyone to read easily!</p>
              <a href="/projects/quranapp" className={styles.button}>View more</a>
            </div>
          </div>
        </div>
        <div className="col-md-6 mb-4">
          <div className={styles.card}>
            <img src={crypto} className={styles.cardImage} alt="Naziv Projekta 2" />
            <div className={styles.cardBody}>
              <h2 className={styles.cardTitle}>Xchanger app</h2>
              <p className={styles.cardText}>Exchange your crypto with ease!</p>
              <a href="/projects/moveitapp" className={styles.button}>View more</a>
            </div>
          </div>
        </div>
        <div className="col-md-6 mb-4">
          <div className={styles.card}>
            <img src={ets1} className={styles.cardImage} alt="Naziv Projekta 3" />
            <div className={styles.cardBody}>
              <h2 className={styles.cardTitle}>ETS-MLIKE</h2>
              <p className={styles.cardText}>Perfect school website for teachers and students!</p>
              <a href="/projects/weatherapp" className={styles.button}>View more</a>
            </div>
          </div>
        </div>
        <div className="col-md-6 mb-4">
          <div className={styles.card}>
            <img src={car} className={styles.cardImage} alt="Naziv Projekta 4" />
            <div className={styles.cardBody}>
              <h2 className={styles.cardTitle}>Online car shop</h2>
              <p className={styles.cardText}>Look for car you like, online!!</p>
              <a href="/projects/rock-paper-scissors" className={styles.button}>View more</a>
            </div>
          </div>
        </div>
        <div className="col-md-6 mb-4">
          <div className={styles.card}>
            <img src={Axel} className={styles.cardImage} alt="Naziv Projekta 2" />
            <div className={styles.cardBody}>
              <h2 className={styles.cardTitle}>AxeL Mobile App!</h2>
              <p className={styles.cardText}>Brand New Furniture Mobile App!</p>
              <a href="/projects/etchasketch" className={styles.button}>View more</a>
            </div>
          </div>
        </div>
        <div className="col-md-6 mb-4">
          <div className={styles.card}>
            <img src={comments} className={styles.cardImage} alt="Naziv Projekta 2" />
            <div className={styles.cardBody}>
              <h2 className={styles.cardTitle}>Comment app</h2>
              <p className={styles.cardText}>An app designed for expressing thoughts and sharing feedback in a simple, user-friendly way.</p>
              <a href="/projects/commentapp" className={styles.button}>View more</a>
            </div>
          </div>
        </div>
        <div className="col-md-6 mb-4">
          <div className={styles.card}>
            <img src={react} className={styles.cardImage} alt="Naziv Projekta 2" />
            <div className={styles.cardBody}>
              <h2 className={styles.cardTitle}>React</h2>
              <p className={styles.cardText}>Simple and elegant react app build with html, tailwindCSS and react!</p>
              <a href="/projects/digitalclock" className={styles.button}>View more</a>
            </div>
          </div>
        </div>
        <div className="col-md-6 mb-4">
          <div className={styles.card}>
            <img src={Ecommerce} className={styles.cardImage} alt="Naziv Projekta 2" />
            <div className={styles.cardBody}>
              <h2 className={styles.cardTitle}>E-commerce</h2>
              <p className={styles.cardText}>Fantastic e-commerce app, sell with ease, made for easy profit!</p>
              <a href="/projects/deliveryapp" className={styles.button}>View more</a>
            </div>
          </div>
        </div>
        <div className="col-md-6 mb-4">
          <div className={styles.card}>
            <img src={Moveit} className={styles.cardImage} alt="Naziv Projekta 2" />
            <div className={styles.cardBody}>
              <h2 className={styles.cardTitle}>Move It!</h2>
              <p className={styles.cardText}>You are planning a move, no problem!</p>
              <a href="/projects/calculatorapp" className={styles.button}>View more</a>
            </div>
          </div>
        </div>
        <div className="col-md-6 mb-4">
          <div className={styles.card}>
            <img src={maproute} className={styles.cardImage} alt="Naziv Projekta 2" />
            <div className={styles.cardBody}>
              <h2 className={styles.cardTitle}>Map-My-Journey</h2>
              <p className={styles.cardText}>MapMyJourney - Navigate Your Way with Ease, One Step at a Time!</p>
              <a href="/projects/temperatureapp" className={styles.button}>View more</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Album;
